import React, { Component } from "react";
import { connect } from 'react-redux';

import lodashGet from 'lodash/get';
import lodashSort from 'lodash/sortBy';
import lodashIsNil from 'lodash/isNil';
import lodashCloneDeep from 'lodash/cloneDeep';

import { createFilterOptions } from '@mui/material/Autocomplete';
import {
    Grid, Typography, TextField, Button, Dialog,
    DialogTitle, DialogContent, DialogActions, FormControl,
    Autocomplete, IconButton, Divider, Select, MenuItem, InputLabel, FormHelperText,
    InputAdornment, Alert,
} from '@mui/material';

import NumberField from "../customComponents/NumberField.tsx";
import VarietyForm from "./varietyForm.jsx";

// Icons
import DeleteIcon from '@mui/icons-material/Delete';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { AddCircleOutline, Warning, InfoOutlined, WarningAmberRounded } from "@mui/icons-material";

/* Redux */
import { CornType, ActionAddVariety, Crop, ActionUpdateVariety } from '../../redux/actions/harvest';

import StringTranslate from '../../assets/i18n/stringLanguage.jsx';

import getTheme from "../../themes/index.js";
let theme = getTheme();

const filter = createFilterOptions();

const defaultHarvest = { id: 0, label: `${StringTranslate.selectItem}`, isGrain: true, isSilage: true, defaultCornDryingTarget: 0, };
const defaultDetail = { sowingPercentage: null, id: 0, clientId: null, label: null, manufacturer: null, harvestCrop: null, varietyInfos: null, degreeThresholdMin: null, degreeThresholdMax: null};

class MultiVarietyForm extends Component {

    constructor (props) {
        super(props);

        const varietyId = lodashGet(props, 'varietyId', 0);
        const defaultHarvestType = lodashGet(props, 'defaultHarvestType', CornType.None);
        const variety = lodashGet(props, `harvestVarietyCharacteristicsDico[${varietyId}]`, {});
        let isAMultiVariety = lodashGet(variety, 'isAMultiVariety', false);
        let label = StringTranslate.multivariety;
        let cornType = defaultHarvestType;
        let percentageHarvestTarget = defaultHarvest.defaultCornDryingTarget;
        let details = [];
        let varietyInfoId = -1;

        if (!isAMultiVariety) {
            details = [{...defaultDetail, ...variety}, {...defaultDetail,}];
        }
        else {
            label = lodashGet(variety, 'label', StringTranslate.multivariety);
            cornType = lodashGet(variety, 'varietyInfos[0].harvestType', defaultHarvestType);
            percentageHarvestTarget = lodashGet(variety, 'varietyInfos[0].percentageHarvestTarget', defaultHarvestType);
            details = lodashCloneDeep(lodashGet(variety, 'details', [{...defaultDetail,}, {...defaultDetail,}]));
            varietyInfoId = lodashGet(variety, 'varietyInfos[0].id', varietyInfoId);
        }

        this.isAMultiVariety = isAMultiVariety;
        this.varietyInfoId = varietyInfoId;
        this.state = {
            label: label,

            cornType: cornType,
            percentageHarvestTarget: percentageHarvestTarget,
            
            details: details, // Initialisation d'une nouvelle ligne]

            totalSowingPercentage: 0,
            labelIsValid: true,
            typeCornIsValid: true,
            percentageHarvestTargetIsValid: true,
            sowingPercentageIsValid: true,
            totalSowingPercentageIsValid: true,
            showErrorSowing: [],
            showErrorVariety: [],

            openDialogVariety: false,
            varietyToAdd: {}, // entité à passé au formulaire de variété (permet de reprendre le nom qu'a taper le user)
            indexToAddVariety: -1,
        }

        this.handleUpdatedDetails = this.handleUpdatedDetails.bind(this);
        this.handleUpdatedVarietyInfos = this.handleUpdatedVarietyInfos.bind(this);
        this.closeDialogVariety = this.closeDialogVariety.bind(this);
    }
    componentDidUpdate(prevProps, prevState) {
        const { addingVariety, lastAddedVariety } = this.props;
        const { openDialogVariety, indexToAddVariety, cornType } = this.state;

        // Si on a fini d'ajouter la variété
        if ((openDialogVariety === true) 
            && ((prevProps.addingVariety === true) && (addingVariety === false)))
        {
            let newCornType = cornType;

            //Vérification que la variété possède au moins un objectif de récolte qui correspond au type de récolte souhaité pour la récolte
            const hasOnlyDifferentHarvestType = lastAddedVariety.varietyInfos.every(variety => variety.harvestType !== cornType);     

            //Si ce n'est pas le cas on change le type de récolte de la parcelle pour qu'elle correspoande
            if (hasOnlyDifferentHarvestType) {
                newCornType = (cornType === CornType.Ensilage) ? CornType.Grain : CornType.Ensilage;
            }

            //On sélectionne la variété dernièrement ajoutée à la parcelle dircetement
            this.handleUpdatedDetails(lastAddedVariety, indexToAddVariety, true);


            this.setState({ cornType: newCornType, openDialogVariety: false, });
        }
    }

    /**
     * Méthode permettant de réaliser des mises à jours liés à l'objet details
     * A la fois pour la variété et le pourcentage
     * @param {*} newValue 
     * @param {Int} index 
     * @param {boolean} isVariety 
     */
    handleUpdatedDetails = (newValue, index, isVariety = false) => {
        const { details, totalSowingPercentage } = this.state;

        const updateDetails = [...details];
        let newTotalSowingPercentage = totalSowingPercentage;

        if (updateDetails[index]) {
            if (isVariety === true) {

                if (newValue !== null){
                    if (newValue.id === -1) {
                        let varietyLabel = lodashGet(newValue, "inputValue", "");
                        updateDetails[index] = {
                            id: defaultHarvest.id,
                            label: varietyLabel
                        }
                        this.setState({
                            varietyToAdd: {
                                varietyId: defaultHarvest.id,
                                label: varietyLabel,
                            }, 
                            details: updateDetails,
                            openDialogVariety: true,
                            indexToAddVariety: index,
                        });

                        return;
                    }

                    updateDetails[index] = {
                        ...updateDetails[index],
                        ...newValue,
                    };
                }
                
            } else {
                if (updateDetails[index]) {
                    updateDetails[index] = {
                        ...updateDetails[index],
                        sowingPercentage: newValue,
                    };

                    newTotalSowingPercentage = 0;
                    for (const detail of updateDetails) {
                        newTotalSowingPercentage += lodashGet(detail, 'sowingPercentage', 0) ?? 0;
                    }
                }
            }
        }

        this.setState({
            details: updateDetails,
            totalSowingPercentage: newTotalSowingPercentage,
        });
    }

    /**
     * Méthode permettant de réaliser des mises à jours liés à l'objet VarietyInfos
     * A la fois pour le type de mais et l'objectif de récolte
     * @param {*} newValue 
     * @param {boolean} isCornType 
     */
    handleUpdatedVarietyInfos = (value, isCornType = false) => {
        const { cornType, percentageHarvestTarget } = this.state;

        let newCornType = cornType;
        let newPercentageHarvestTarget = percentageHarvestTarget;
    
        if (value !== null) {
            if (isCornType === true) {
                newCornType = value;
                newPercentageHarvestTarget = defaultHarvest.defaultCornDryingTarget;
            } else { 
                newPercentageHarvestTarget = value;
            }
        }

        this.setState({
            cornType: newCornType,
            percentageHarvestTarget: newPercentageHarvestTarget,
        });
    }

    handleAddLabelMultiVariety = (newValue) => {

        if (newValue !== null) {
            this.setState({
                label: newValue
            })
        }
    }

    /**
     * Méthode permettant de controlé les champs saisi par l'utilisateur
     * @param {} harvestVariety 
     * @returns {boolean}
     */
    controlData(harvestVariety) {
        let isValid = true;
        const errorSowing = [];
        const errorVariety = [];


        let labelIsValid = true;
        let typeCornIsValid = true;
        let percentageHarvestTargetIsValid = true;
        let varietyIsValid = true;
        let sowingPercentageIsValid = true;
        let totalSowingPercentageIsValid = true;
        if (lodashIsNil(harvestVariety.label) || harvestVariety.label === "") {
            isValid = false;
            labelIsValid = false;
        }

        // VarietyInfo
        // Type de grain
        if (harvestVariety.varietyInfos[0].harvestType === null)  {
            isValid = false;
            typeCornIsValid = false;
        }

        // Objectif de récolte
        if (harvestVariety.varietyInfos[0].percentageHarvestTarget === defaultHarvest.defaultCornDryingTarget) {
            isValid = false;
            percentageHarvestTargetIsValid = false;
        }

        let totalSowing = 0;
        // Details
        harvestVariety.details.forEach((detail, index) => {

            // Vérification de la variété
            if (detail.id === null || detail.id <= 0 || detail.id === defaultHarvest.id) {
                isValid = false;
                varietyIsValid = false
                errorVariety[index] = {valid: varietyIsValid, messageError: StringTranslate.champobligatoire};
            }
            
            // Vérification du pourcentage
            if (detail.sowingPercentage === null) {
                isValid = false;
                sowingPercentageIsValid = false;
                errorSowing[index] = {valid: sowingPercentageIsValid, messageError: StringTranslate.champobligatoire};
            }
            else if (detail.sowingPercentage > 99 || detail.sowingPercentage < 1) {
                isValid = false;
                sowingPercentageIsValid = false;
                errorSowing[index] = {valid: sowingPercentageIsValid, messageError: StringTranslate.multiVarietySowingPercentageError}
            }

            totalSowing += detail.sowingPercentage;
        });

        if (totalSowing !== 100 || totalSowing === null || totalSowing === 0) {
            isValid = false;
            sowingPercentageIsValid = false;
            totalSowingPercentageIsValid = false;
        }

        this.setState({
            labelIsValid: labelIsValid,
            typeCornIsValid: typeCornIsValid,
            percentageHarvestTargetIsValid: percentageHarvestTargetIsValid,
            showErrorSowing: errorSowing,
            showErrorVariety: errorVariety,
            sowingPercentageIsValid: sowingPercentageIsValid,
            totalSowingPercentageIsValid: totalSowingPercentageIsValid,
        })
        return isValid;
    }

    /**
     * TODO: Reste à créer les controlleurs pour bloquer l'accès sans vérif
     * Méthode permettant de sauvegarder les choix pour la multi variété et lance également l'ajout de celle-ci ainsi que ça création
     * Et retourne ensuite à l'écran principale
     */
    saveMultivariety() {
        const { label, cornType, percentageHarvestTarget, details } = this.state;
        const { addVariety, updateVariety, clientId, varietyId } = this.props;

        let isAMultiVariety = this.isAMultiVariety;

        const harvestVariety = {
            id: isAMultiVariety? varietyId: 0,  //sera renseigné suite à l'ajout en BdD
            clientId: clientId,
            label: label,
            manufacturer: StringTranslate.customised,
            harvestCrop: {   //TODO: Adapter quand plusieurs cultures pour récoltes               
                id: 1,
                enumCrop: Crop.Corn,
            },
            flowering: null, // sera calculé côté serveur
            varietyInfos: [{
                harvestType: cornType,
                percentageHarvestTarget: percentageHarvestTarget,
                //sumDegreeDayHarvestTarget: sera calculé côté serveur
            }],
            details: details,
            degreeThresholdMin: 6,
            degreeThresholdMax: 30,
        }
    
        let isValid = this.controlData(harvestVariety);

        if (isValid) {
            if (isAMultiVariety)
                updateVariety(harvestVariety);
            else
                addVariety(harvestVariety);
        }
    }   

    /**
     * Méthode permettant d'afficher un visuel permettant de choisir une variété en fonction de la ligne souhaiter
     * @param {*} index 
     * @returns 
     */
    displayChoiceVariety(index) {
        const { harvestVarietyCharacteristicsDico, } = this.props;
        const { details, showErrorVariety } = this.state;

        return (
            <FormControl fullWidth size="small" key={`variety-input-${index}`}>
                <Autocomplete
                id={`select-variety-id-${index}`}
                disableClearable
                value={(details[index].id === defaultHarvest.id || !details[index].id)
                    ? null
                    : harvestVarietyCharacteristicsDico[details[index].id]}
                onChange={(event, newValue) => this.handleUpdatedDetails(newValue, index, true)} // Passer l'index
                getOptionLabel={(value) => value.label || ''}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    const isExisting = options.some((option) => inputValue === option.label);
                    if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        label: `${StringTranslate.ajouter3} "${inputValue}"`,
                        id: -1,
                    });
                    }
                    return filtered;
                }}
                getOptionKey={(value) => value.id}
                options={lodashSort(harvestVarietyCharacteristicsDico, ['label'], ['desc'])}
                renderOption={(props, option) => (
                    <li {...props} key={`${option?.id}-${index}`}>
                    {(option?.id === -1)
                        ? <Button color="primary" variant="contained" >{option.label}</Button>
                        : option?.label}
                    </li>
                )}
                renderInput={(inputParams) => (
                    <TextField
                        {...inputParams}
                        size="small"
                        label={`${StringTranslate.harvestVariety} ${index + 1} *`}
                        placeholder={defaultHarvest.label}
                        onKeyDown={(e) => e.key === " " && e.stopPropagation()}
                        error={showErrorVariety[index]?.valid === false}
                        helperText={(showErrorVariety[index]?.valid === false) ? showErrorVariety[index]?.messageError : null}
                    />
                )}
                
                />
          </FormControl>
        )
    }

    // Ajout d'une ligne lors du clique sur le bouton
    handleAddLine = () => {
        const { details, } = this.state;

        this.setState({
            details: [...details, {...defaultDetail,}],
        });
    };

    // Réalise la suppression de l'index sélectionner (Possible uniquement lorsqu'on à 3 ligne pour le tableau 2)
    handleDeleteLine = (index) => {
        const { details } = this.state;
        
        const updatedDetails = [...details];
        updatedDetails.splice(index, 1); 
        
        this.setState({
            details: updatedDetails,
        });
    }

    /**
     * Méthode permettant d'afficher le sélecteur permettant de choisir le type de mais
     * @returns Visuel de choix pour le type de mais
     */
    displayTypeCorn() {
        const { cornType, typeCornIsValid } = this.state;
        return (
            <FormControl fullWidth size="small" error={!typeCornIsValid}>
                <InputLabel id="label-cornType" >{`${StringTranslate.cornType} *`}</InputLabel>
                <Select
                    id="select-cornType"
                    labelId="label-cornType"
                    label={`${StringTranslate.cornType} *`}
                    value={cornType}
                    onChange={(event) => this.handleUpdatedVarietyInfos(event.target.value, true)}
                    error={(typeCornIsValid) ? null : "Error"}
                >
                    {(cornType === CornType.None) && <MenuItem value={CornType.None} disabled><em>{StringTranslate.selectItem}</em></MenuItem>}
                    <MenuItem value={CornType.Ensilage}>{StringTranslate.ensilage}</MenuItem>
                    <MenuItem value={CornType.Grain}>{StringTranslate.grain}</MenuItem>
                </Select>
            </FormControl>
        )
    }

    /**
     * Méthode permettant d'afficher le sélecteur permettant de choisir l'objectif de récolte
     * @returns Visuel de choix pour l'objectif de récolte
     */
    displayDry() {
        const { cornDryingInfos } = this.props;
        const { percentageHarvestTarget, cornType, percentageHarvestTargetIsValid } = this.state;

        const labelPercentageHarvestTarget = 
                            (cornType === CornType.Ensilage) ? StringTranslate.dryMaterial:
                            (cornType === CornType.Grain) ? StringTranslate.humidity : "";


        const cornDryingInfo = lodashGet(cornDryingInfos, `${cornType}`, undefined);
        const cornDryingList = lodashGet(cornDryingInfo, 'dryingList', []);

        return (
            <FormControl fullWidth size="small">
                <InputLabel
                    error={(percentageHarvestTargetIsValid === false)}
                >{StringTranslate.percentage} *</InputLabel>
                <Select
                    id="select-percentage"
                    value={percentageHarvestTarget}
                    label={`${StringTranslate.percentage} *`}
                    onChange={(event) => this.handleUpdatedVarietyInfos(event.target.value)}
                    error={(percentageHarvestTargetIsValid === false)}
                    MenuProps={{ PaperProps: { style: { maxHeight: '33%' } } }}
                >
                    {/* select default */}
                    {(percentageHarvestTarget === defaultHarvest.defaultCornDryingTarget) && 
                        <MenuItem key={defaultHarvest.defaultCornDryingTarget} value={defaultHarvest.defaultCornDryingTarget} disabled>{defaultHarvest.label}</MenuItem>}

                    {cornDryingList.map((itemDry) => {
                        return <MenuItem key={itemDry} value={itemDry}>{itemDry}% {labelPercentageHarvestTarget}</MenuItem>
                    })}
                </Select>
                {(percentageHarvestTargetIsValid === false) ? <FormHelperText error>{StringTranslate.champobligatoire}</FormHelperText> : null}
            </FormControl>
        )
    }

    displayAddLabelMultiVariety() {
        const { label, labelIsValid } = this.state;
        return (
            <FormControl fullWidth size="small">
                <TextField
                    value={label}
                    onChange={(event) => this.handleAddLabelMultiVariety(event.target.value)}
                    label={`${StringTranslate.multiVarietyLabel} *`}
                    error={(labelIsValid === false)}
                    helperText={(labelIsValid === false) ? StringTranslate.champobligatoire : null}
                />
            </FormControl>
        )
    }

    displayTotalSowingPercentageHelper() {
        const { totalSowingPercentage } = this.state;
        if (totalSowingPercentage < 100){
            return (<Alert
                severity="info"
                icon={<InfoOutlined />}
            >
                <Typography>{StringTranslate.formatString(StringTranslate.totalSowingPercentageBelow, 100 - totalSowingPercentage)}</Typography>
            </Alert>)
        }
        else if (totalSowingPercentage > 100){
            return (<Alert
                severity="error"
                icon={<WarningAmberRounded />}
            >
                <Typography>{StringTranslate.formatString(StringTranslate.totalSowingPercentageAbove, totalSowingPercentage -100)}</Typography>
            </Alert>)
        }
        else if (totalSowingPercentage === 100) {
            return (<Alert
                severity="success"
                icon={<TaskAltIcon />}
                sx={{ backgroundColor: theme.palette.success.light }}
            >
                <Typography>{StringTranslate.totalSowingPercentageEqual}</Typography>
            </Alert>)
        }
    }

    closeDialogVariety = () => {
        this.setState({ openDialogVariety: false, });
    }

    render () {
        const { details, showErrorSowing, totalSowingPercentageIsValid, sowingPercentageIsValid, openDialogVariety, varietyToAdd } = this.state;
        const { openDialog, closeDialog } = this.props;

        return (
            <>
                    {/* ↓↓ Partie visuel - affichage Popup pour la modification d'une variété ↓↓ */}
                    {openDialogVariety ?
                        <VarietyForm
                            isOpen={openDialogVariety}
                            onClose={this.closeDialogVariety}
                            variety={varietyToAdd} action={"add"}/>
                    : null}


                    <Dialog 
                        maxWidth="sm"
                        open={openDialog}
                        onClose={closeDialog}
                        // TODO Normalement la props "maxWidth" est censé appliqué cette valeur mais est actuellement surchargé par une classe CSS du PinDropPopup
                        sx={{
                            '& .MuiPaper-root':{
                                maxWidth: "600px !important",
                            },
                        }}
                    >
                        <DialogTitle>
                            <Typography>{StringTranslate.addMultiVariety}</Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {this.displayAddLabelMultiVariety()}
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    {this.displayTypeCorn()}
                                </Grid>
                                <Grid item xs={6}>
                                    {this.displayDry()}
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogContent dividers>  
                            {(totalSowingPercentageIsValid === false) && 
                                <Alert
                                    severity="error"
                                    icon={<Warning/>}
                                    sx={{marginBottom: 2}}
                                >
                                    <Typography>{StringTranslate.multiVarietyErrorSumSowingPercentage}</Typography>
                                </Alert>}
 
                            <Grid container spacing={2}>
                            {details.map((detail, index) => (
                                <Grid item xs={12} key={`variety-row-${index}`}>
                                    <Grid container spacing={2}>
                                        <Grid item sm={6}>
                                            {this.displayChoiceVariety(index)}
                                        </Grid>
                                        <Grid item sm={4}>
                                            <NumberField
                                                id={`variety-percentage-${index}`}
                                                value={detail.sowingPercentage}
                                                onChange={(event) => this.handleUpdatedDetails(event, index)}
                                                type="uInteger"
                                                label={`${StringTranslate.multiVarietySowingPercentage} *`}
                                                size='small'
                                                error={(showErrorSowing[index]?.valid === false) || (sowingPercentageIsValid === false)}
                                                helperText={(showErrorSowing[index]?.valid === false) ? showErrorSowing[index]?.messageError : null}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            {details.length > 2 ? (
                                                <IconButton onClick={() => this.handleDeleteLine(index)} aria-label="Ajout multi-variété" style={{ alignItems: "center", }} color="error">
                                                    <DeleteIcon /> 
                                                </IconButton>
                                            ) : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                                <Grid item xs={12}>
                                    {this.displayTotalSowingPercentageHelper()}
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider textAlign="center">
                                        <IconButton onClick={this.handleAddLine} variant="outlined" color="primary">
                                            <AddCircleOutline />
                                        </IconButton>
                                    </Divider>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => closeDialog()} variant="text" color="error">{StringTranslate.cancelDeleteAction}</Button>
                            <Button onClick={() => this.saveMultivariety()} color="primary" autoFocus variant="contained">
                            {StringTranslate.enregistrer}
                            </Button>
                        </DialogActions>
                    </Dialog>
            </>
        )
    }
}

const mapStateToProps = state => ({
    /* Harvest */
    harvestDico: lodashGet(state, 'harvestData.harvestDico', {}),
    harvestVarietyCharacteristicsDico: lodashGet(state, 'harvestData.harvestVarietyCharacteristicsDico', {}),
    harvestVarietyCharacteristicsDicoCounter: lodashGet(state, 'harvestData.harvestVarietyCharacteristicsDicoCounter', 0),
    currentCrop: lodashGet(state, 'harvestData.currentCrop', false),
    addingVariety: lodashGet(state, 'harvestData.addingVariety', false),
    lastAddedVariety: lodashGet(state, 'harvestData.lastAddedVariety', {}),
    
    cornDryingInfos: lodashGet(state, 'harvestData.cornDryingInfos', {}),
    cornDryingList: lodashGet(state, 'harvestData.cornDryingList', []), //spécifique maïs Grain !!!!

    /* Settings */
    language: lodashGet(state, 'settingsData.settings.language', StringTranslate.getLanguage()),

    //Infos provenant du reducer 'clientUserData':
    clientId: lodashGet(state, 'clientUserData.clientDatas.id', -1),
});

/* fonction permettant de fournir les fonctions (actions) au composant HOComponent */
const mapDispatchToProps = dispatch => ({
    addVariety: (newVariety) => dispatch(ActionAddVariety(newVariety)),
    updateVariety: (variety) => dispatch(ActionUpdateVariety(variety)),
})


export default connect(mapStateToProps, mapDispatchToProps)(MultiVarietyForm);